import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import { observer } from 'mobx-react'

import { Col, Row, Pagination } from 'react-bootstrap'
import PerPage from '../../components/PerPage'
import { TABLE_VIEW } from '../../constants'

@observer
class NavBar extends Component {
  constructor(props) {
    super(props)
    this.handlePageClick = this.handlePageClick.bind(this)
    this.handleNumItemPerPageChange = this.handleNumItemPerPageChange.bind(this)
  }

  handlePageClick(page) {
    this.props.router.push(`/page/${page}`)
    //this.props.store.setCurrentPage(page);
    //this.props.store.fetchPageItemsFromServer();
  }

  handleNumItemPerPageChange(num) {
    this.props.store.setNumItemsPerPage(num)
  }

  render() {
    const { store } = this.props
    let { begin, end } = store
    const total = store.filteredIds.length
    begin = begin + 1

    return (
      <Row>
        <Col sm={8}>
          <Pagination
            prev="&larr; Previous"
            next="Next &rarr;"
            first={false}
            last={false}
            ellipsis={true}
            boundaryLinks={true}
            items={store.numPages}
            maxButtons={3}
            activePage={store.currentPage}
            onSelect={this.handlePageClick}
            style={{ marginTop: 10 }}
          />
        </Col>
        <Col sm={2}>
          <div className="text-muted">Items</div>
          <span className="text-muted">
            {begin}-{end} of {total}
          </span>
        </Col>
        <Col sm={2}>
          {
            /* Only show if we have more than 50 items. */
            store.displayMode === TABLE_VIEW && total > 50 && (
              <PerPage
                total={total}
                onChange={this.handleNumItemPerPageChange}
                currentNumItemsPerPage={store.numItemsPerPage}
              />
            )
          }
        </Col>
      </Row>
    )
  }
}

NavBar.propTypes = {
  store: PropTypes.object.isRequired,
}

export default withRouter(NavBar)
